import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { AuthResponseDto } from '../api-client/models';

@Injectable({ providedIn: 'root' })
export class UserService {

  private readonly _user$ = new BehaviorSubject<AuthResponseDto | null>(null);
  readonly user$ = this._user$.asObservable();
  private readonly lagesioAuthKey = 'lagesio_auth';

  constructor() {
    const saved = localStorage.getItem(this.lagesioAuthKey);
    if (saved) {
      this._user$.next(JSON.parse(saved));
    }
  }

  accessToken(): string | null {
    return this._user$.value?.accessToken ?? null;
  }

  getOrganizations() {
    return this._user$.value?.organizations ?? [];
  }

  getUser() {
    return this._user$.value?.user ?? null;
  }

  getUserName() {
    return this._user$.value?.user?.displayName ?? null;
  }

  getSelectedOrganizationId() : string | null {
    return this._user$.value?.selectedOrganizationId ?? null;
  }

  getSelectedOrganization() {
    const orgId = this.getSelectedOrganizationId();
    return this.getOrganizations().find(org => org.id === orgId) || null;
  }

  restore(res: AuthResponseDto) {
    this._user$.next(res);
    localStorage.setItem(this.lagesioAuthKey, JSON.stringify(res));
  }  
  
  setAccessToken(accessToken: string, expiresAt: string) {
    const current = this._user$.value;
    if (!current) return;

    const next: any = { ...current, accessToken, expiresAt };
    this._user$.next(next);
    localStorage.setItem(this.lagesioAuthKey, JSON.stringify(next));
  }

  remove() {
    this._user$.next(null);
    localStorage.removeItem(this.lagesioAuthKey);
  }
}
